import { useEffect, useState } from "react";

export function useMediaQuery(query: string): boolean {
	// Get initial value synchronously on client to avoid flash of wrong layout
	const getMatches = () => {
		if (typeof window !== "undefined") {
			return window.matchMedia(query).matches;
		}
		return false;
	};

	const [matches, setMatches] = useState(getMatches);

	useEffect(() => {
		const media = window.matchMedia(query);

		// Update the state with the current value
		const updateMatches = () => setMatches(media.matches);

		// Set initial value (in case it changed between render and effect)
		updateMatches();

		// Add listener for changes
		media.addEventListener("change", updateMatches);

		// Clean up
		return () => media.removeEventListener("change", updateMatches);
	}, [query]);

	return matches;
}
